import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { AnalysisRequestNewRegisterButton } from '../../../../../components/Common/AnalysisRequestNewRegisterButton';
import { Expander } from '../../../../../components/Common/Expander';
import Table1 from "../../../../../components/Common/TableContainer"
import { TableItemDeleteModal } from '../../../../../components/Common/TableItemDeleteModal';
import { addNewLabRequestEssay, deleteLabRequestEssay, getLabRequestEssays, getLabRequestTestSamples, updateLabRequestEssay } from '../../../../../store/actions';
import { NewRegisterTestModal } from './NewRegisterTestModal';

export const TestGenerationTab = ({props}) => {

    const role = (localStorage.getItem("authUser")) ?  JSON.parse(localStorage.getItem("authUser"))?.role : ''

    // Modal para Registrar ensayo
    const [showModal1, setShowModal1] = useState(false);
    // Modal de borrar una muestra asignada al ensayo
    const [showModal2, setShowModal2] = useState(false);
    // Para la información de cada renglón
    const [rowInfo, setRowInfo] = useState();

    const [isUpdate, setIsUpdate] = useState(false);

    const [finalArray, setFinalArray] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestEssays(`?limit=20&page=0&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`));
        dispatch(getLabRequestTestSamples(`?limit=20&page=0&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`));
    }, [])

    const { labRequestTests, labRequestEssays, labRequestEssay, loading, total, currentPage, labRequestTestSamples } = useSelector(state => ({
        labRequestEssays: state.labRequestEssayReducer.labRequestEssays, // TODO: Ésta variable va en la "data" de la tabla para seleccionar muestras que se van a agregar a cada ensayo
        labRequestEssay: state.labRequestEssayReducer.labRequestEssay,
        loading: state.labRequestEssayReducer.loading,
        total: state.labRequestEssayReducer.total,
        currentPage: state.labRequestEssayReducer.currentPage,
        labRequestTests: state.labRequestTestReducer.labRequestTests,
        labRequestTestSamples: state.labRequestTestSampleReducer.labRequestTestSamples,
    }), shallowEqual);

    // * Redux fin

    useEffect(() => { // TODO: Si no funciona puede que no este entrando al Effect cuando pienso que debe de entrar

        const firstArray = labRequestTestSamples.map((sample) => sample.labRequestSample?.serviceIdentifier ?? '');

        setFinalArray(firstArray.filter((item, index) => { // Borrado de elementos repetidos de un array
            return firstArray.indexOf(item) === index;
        }))

        // console.log('Array lab request samples', firstArray, finalArray, labRequestTestSamples)

    }, [labRequestTestSamples])

    // console.log('labRequestTestSamples: ', labRequestTestSamples);

    const onDelete = (values) => {
        setRowInfo(values);
        // console.log('Valores delete: ', values)
        setShowModal2(true);
    }

    const onDeleteConfirmation = () => {
        // console.log('Borrado confirmado');
        dispatch(deleteLabRequestEssay(rowInfo));
        setRowInfo('');
    }

    const getPagination = (params) => {
        dispatch(getLabRequestEssays(`${params}&labRequestTest=${props?.match?.params?.rowInfoLabTestViewId}`));
    }

    const modalClose = () => {
        setIsUpdate(false);
    }

    const addPropertyPost = (values, sampleItem) => {
        return {
            ...values,
            // sample: parseInt(sampleItem),
            labRequestTest: props?.match?.params?.rowInfoLabTestViewId,
        }
    }

    const modalRespInfo = (values) => { // TODO: values son los valores del formulario y "sample" es un arreglo

        if (isUpdate) {
            // Poner en el objeto el "id"
            const valuesUpdate = {
                ...values,
                // labRequestTest: rowInfoLabTestView.id,
                id: rowInfo.id,
            }
            dispatch(updateLabRequestEssay(valuesUpdate));
        } else {

            // Promise.all( // Hacemos el dispatch de todos los elementos del arreglo de id Tests al mismo tiempo
            //     (values.sample).map((sampleItem) => dispatch(addNewLabRequestEssay(addPropertyPost(values, sampleItem))))
            // )
            dispatch(addNewLabRequestEssay(addPropertyPost(values)))

            // const valuespost = {
            //     ...values,
            //     labRequestTest: rowInfoLabTestView.id,
            // }
            // // console.log('valuespost: ', valuespost);
            // dispatch(addNewLabRequestEssay(valuespost));
        }
        setIsUpdate(false);
        setRowInfo('');


        // Aqui van a ir los dispatch para el post de la info del modal de nuevo registro

        // TODO: Se debe de realizar un "post" al servicio:
        // "Lab Request Essay" 
        // Aqui falta el campo para mandar el lab request id?
        // Sólo esta el lab reques test.

    }

    const onUpdate = (values) => {
        // console.log('Valores update: ', values);
        setIsUpdate(true);
        setRowInfo(values);
        setShowModal1(true);
    }

    const columns = React.useMemo(
        () => [
            Expander,
            {
                Header: 'Comentario de Ensayo',
                accessor: 'comments', // TODO: Éste si está bien?
                width: '10%',
            },
            {
                Header: 'Muestras',
                accessor: 'sample',
                width: '10%',
            },
            {
                Header: 'Fecha de ejecución',
                accessor: 'datedAt',
                width: '10%',
                Cell: ({ cell: { value } }) => (
                    <span>{value ? value.substring(0, 10) : '-'}</span>
                )
            },
            {
                Header: 'Documentación Soporte',
                // accessor: 'supportingDocumentation',
                width: '10%',
                Cell: ({ row }) => (
                    <a className='text-primary p-0 m-0' href={row.original.documentation} target='_blank' rel='noreferrer' ><span className="mdi mdi-36px mdi-file-pdf p-0 m-0" style={{ color: 'red' }} ></span></a>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0 me-2" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                        <a className='btn btn-outline-secondary text-primary mx-1 rounded-3 p-0' href={row.original.documentation} target='_blank' rel='noreferrer' ><span className="mdi mdi-18px mdi-file-pdf p-2"></span></a>
                        {/* <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0" onClick={() => { onPDF(row.original) }}> <span className="mdi mdi-24px mdi-file-pdf p-2"></span> </button> */}
                    </div>
                ),
            },
        ],
        []
    )

    const renderRowSubComponent = React.useCallback(
        ({ row }) => (
            <div className='px-4 mx-3'> {row.original.comments} </div>
        ),
        []
    )

    const valSelector = (e) => {
        console.log('event selector: ', e.target.options);
        const array = [...e.target.options].filter(({ selected }) => selected == true);
        console.log('array: ', array);
        const array2 = array.map((value, index) => value.attributes.value.value);
        console.log('array2: ', array2);
    }

    return (
        <>

            <div className='d-flex align-items-center justify-content-between'>
                <h4 className='text-center text-primary'>Documentación de ensayos</h4>
                <AnalysisRequestNewRegisterButton disabled={(role ==='Asesor Técnico') || labRequestTests[0]?.labRequest?.generalStatus === 'Concluida' || labRequestTests[0]?.labRequest?.generalStatus === 'Cancelada' } showModal={showModal1} setShowModal={setShowModal1} text={'Registrar ensayo'} />
                <NewRegisterTestModal selectorArray={finalArray} props={props} showModal={showModal1} setShowModal={setShowModal1} isUpdate={isUpdate} modalClose={modalClose} rowInfo={rowInfo} modalRespInfo={modalRespInfo} modalHeader='Generación de ensayos' />
            </div>

            <Table1 renderRowSubComponent={renderRowSubComponent} currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestEssays} />
            <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} showModal={showModal2} setShowModal={setShowModal2} modalHeader='¿Quiere eliminar éste ensayo?' modalBodyLabel='Una vez eliminado, desaparecera definitivamente' icon='warning' />

        </>
    )
}
